import React, { useEffect } from 'react'
import Breadcrumb from 'Components/UI/Breadcrumb';
import { Container } from 'reactstrap';
import Stripe from './Stripe'; 
import { getAdminSettings } from 'helpers/API Calls/System & Settings/Admin Settings';
import Spinner from 'Components/UI/Spinner';
import BookingCharges from './BookingCharges';
import AnalyticsData from './Analytics';
import Deposits from './Deposits';
import Website from './Website';
import SMS from './SMS';
import Logo from './Logo';

function General() {
  const [isLoading, setIsLoading] = React.useState(true);
  const [data, setData] = React.useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAdminSettings();
        if (response.success) {
          const result = Object.fromEntries(response?.data.map(item => [item.key, item]));
          setData(result);
        }
      setIsLoading(false);
    };
    fetchData();
  }, []);


  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "General Settings", link: "/general" }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinner/></div>
        :
        <>
        <Stripe data={data}/>
        <BookingCharges data={data}/>
        <SMS data={data}/>
        <Deposits data={data}/>
        <AnalyticsData data={data}/>
        <Website data={data}/>
        <Logo />
        </>
      }
       
      </Container>
    </div>
  )
}

export default General
